import { defineMessage } from 'services/localization';

export const messages = {
    ready: defineMessage('ready_to_pay'),
    paid: defineMessage('paid'),
    failed: defineMessage('failed'),
    cancelled: defineMessage('cancelled'),
    processing: defineMessage('processing'),
    scheduled: defineMessage('scheduled'),
    failedTooltip: defineMessage('attempt_failed_please_try_again'),
};
